import { createSlice } from '@reduxjs/toolkit'

import { baseModelState, updateExtraReducers, openForm, closeForm } from 'store/common'
import api from './api'


const initialState = {
  ...baseModelState,
}


export const buildingPlace = createSlice({
  name: 'buildingPlace',
  initialState,
  reducers: {
    openForm,
    closeForm,
  },
  extraReducers: (builder) => {
    updateExtraReducers(builder, api.endpoints.updateBuildingPlace);
  },
});

export default buildingPlace.reducer;

export const BuildingPlaceActions = buildingPlace.actions;
